import { createNotImplementedMethod } from '../utils';
var NotImplementedCalorieRangeRepository = /** @class */ (function () {
    function NotImplementedCalorieRangeRepository() {
        this.updateCalorieRange = createNotImplementedMethod();
    }
    return NotImplementedCalorieRangeRepository;
}());
export { NotImplementedCalorieRangeRepository };
